import { combineReducers } from 'redux';
import { get } from 'lodash';

const stateChart = {
  idle: {
    ADD_STOCK_NOTIFICATION: 'updatePending',
    REMOVE_STOCK_NOTIFICATION: 'updatePending',
    GET_STOCK_NOTIFICATIONS_PENDING: 'getPending'
  },
  getPending: {
    GET_STOCK_NOTIFICATIONS_FULFILLED: 'idle',
    GET_STOCK_NOTIFICATIONS_REJECTED: 'idle'
  },
  updatePending: {
    ROLLBACK_ADD_STOCK_NOTIFICATION: 'idle',
    ROLLBACK_REMOVE_STOCK_NOTIFICATION: 'idle',
    STOCK_NOTIFICATION_ADDED: 'idle',
    STOCK_NOTIFICATION_REMOVED: 'idle'
  }
};

const currentStateReducer = (currentState = 'idle', { type }) =>
  get(stateChart, `${currentState}.${type}`, currentState);


const productIdsReducer = (productIds = [], { type, payload }) => {
  switch (type) {
    case 'GET_STOCK_NOTIFICATIONS_FULFILLED': {
      const { data } = payload;

      return data.map(({ attributes }) => String(attributes['product-id']));
    }

    case 'ADD_STOCK_NOTIFICATION':
    case 'ROLLBACK_REMOVE_STOCK_NOTIFICATION': {
      let { productId } = payload;
      productId = String(productId);

      if (productIds.includes(productId)) return productIds;

      return [...productIds, productId];
    }

    case 'REMOVE_STOCK_NOTIFICATION':
    case 'ROLLBACK_ADD_STOCK_NOTIFICATION': {
      let { productId } = payload;
      productId = String(productId);

      if (!productIds.includes(productId)) return productIds;

      return productIds.filter(id => id !== productId)
    }

    default:
      return productIds;
  }
}

export default combineReducers({
  currentState: currentStateReducer,
  productIds: productIdsReducer
});



// WEBPACK FOOTER //
// ./src/reducers/stockNotificationsReducer.js